module.exports = __webpack_public_path__ + "static/media/stage7.0565cb79.svg";